import _ from "lodash";
import Vue from "vue";

import { set } from "@/utils/vuex";

const EVENT_UPDATE_INTERVAL = 1000;
const EVENT_MAX_AGE = 30000;

const getInitState = () => ({
	eventLog: {},
});

export default {
	namespaced: false,
	state: getInitState(),

	getters: {
		eventData: state => path => _.get(state.eventLog, path),
	},

	mutations: {
		setEventLog: set("eventLog"),

		logEvent(state, { event, data }) {
			state.eventLog = {
				...state.eventLog,
				[event]: {
					firedAt: Date.now(),
					timeAgo: "Just now",
					data,
				},
			};
		},

		resetState(state) {
			Object.assign(state, getInitState());
		},
	},

	actions: {
		init({ dispatch }) {
			setInterval(() => {
				// Double wrapped to prevent 'setInterval callback took too
				// long' message in console.
				Vue.nextTick(() => dispatch("updateEvents"));
			}, EVENT_UPDATE_INTERVAL);
		},

		updateEvents({ state, commit }) {
			if (!_.size(state.eventLog)) {
				// There are no current events in the log. Nothing to do here.
				return;
			}

			const now = Date.now();

			const events = _.reduce(
				state.eventLog,
				(accum, event, path) => {
					const timeDiff = now - event.firedAt;

					// Prune old events past their expiration
					const prune = timeDiff > EVENT_MAX_AGE;
					if (prune) return accum;

					// Update 'time ago' values for remaining events
					const timeAgoSecs = Math.round(timeDiff / 1000);
					const timeAgo = timeAgoSecs ? `${timeAgoSecs}s ago` : "Just now";

					accum[path] = {
						...event,
						timeAgo,
					};
					return accum;
				},
				{}
			);

			commit("setEventLog", events);
		},

		modelEventFired: {
			root: true,
			handler({ commit, dispatch }, { event, data }) {
				this._vm.$log(
					`Event fired: ${event} with data: ${JSON.stringify(data)}`
				);
				commit("logEvent", { event, data });
			},
		},
	},
};
